"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TaxCharge = exports.TaxBreakdown = exports.Phone = exports.Payments = exports.Order = exports.FeeCharge = exports.FeeBreakdown = exports.FareInfo = exports.Fare = exports.CustomerInfo = exports.BpcRequest = exports.BigLoyaltyIds = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  PropTypes: {
    authToken: _propTypes.string.isRequired,
    numberOfPassengers: _propTypes.number.isRequired,
    currency: _propTypes.string.isRequired,
    baseFare: _propTypes.number.isRequired,
    tax: _propTypes.number.isRequired,
    totalAmount: _propTypes.number.isRequired,
    environment: _propTypes.string
  },
  DefaultProps: {
    environment: _constant.DEFAULT_ENV
  }
};
exports.default = _default;
var FeeBreakdown = {
  amount: _propTypes.default.number,
  name: _propTypes.default.string,
  type: _propTypes.default.string
};
exports.FeeBreakdown = FeeBreakdown;
var TaxBreakdown = {
  amount: _propTypes.default.number,
  name: _propTypes.default.string,
  type: _propTypes.default.string
};
exports.TaxBreakdown = TaxBreakdown;
var FeeCharge = {
  totalAmount: _propTypes.default.number,
  breakdown: _propTypes.default.arrayOf(FeeBreakdown)
};
exports.FeeCharge = FeeCharge;
var TaxCharge = {
  totalAmount: _propTypes.default.number,
  breakdown: _propTypes.default.arrayOf(TaxBreakdown)
};
exports.TaxCharge = TaxCharge;
var FareInfo = {
  currency: _propTypes.default.string,
  totalAmount: _propTypes.default.number,
  strikeThrough: _propTypes.default.number,
  exclusive: _propTypes.default.number,
  tax: _propTypes.default.shape(TaxCharge),
  fee: _propTypes.default.shape(FeeCharge)
};
exports.FareInfo = FareInfo;
var Fare = {
  invoiceCurrency: _propTypes.default.shape(FareInfo)
};
exports.Fare = Fare;
var Phone = {
  countryCode: _propTypes.default.string,
  number: _propTypes.default.string
};
exports.Phone = Phone;
var CustomerInfo = {
  firstName: _propTypes.default.string,
  lastName: _propTypes.default.string,
  title: _propTypes.default.string,
  number: _propTypes.default.string,
  email: _propTypes.default.string,
  phone: _propTypes.default.shape(Phone),
  ssoId: _propTypes.default.string,
  bigLoyaltyId: _propTypes.default.string,
  customerIp: _propTypes.default.string,
  userCulture: _propTypes.default.string
};
exports.CustomerInfo = CustomerInfo;
var Payments = {
  transactionDate: _propTypes.default.string,
  paymentStatus: _propTypes.default.string,
  amount: _propTypes.default.number,
  processingFee: _propTypes.default.number,
  currency: _propTypes.default.string,
  transactionId: _propTypes.default.string,
  referenceId: _propTypes.default.string,
  paymentMethod: _propTypes.default.string
};
exports.Payments = Payments;
var Order = {
  createdAt: _propTypes.default.string,
  orderId: _propTypes.default.number,
  status: _propTypes.default.string,
  orderType: _propTypes.default.string,
  customerInfo: _propTypes.default.shape(CustomerInfo),
  fare: _propTypes.default.shape(Fare),
  payments: _propTypes.default.arrayOf(Payments)
};
exports.Order = Order;
var BigLoyaltyIds = {
  bigLoyaltyId: _propTypes.default.string,
  memberTier: _propTypes.default.string
};
exports.BigLoyaltyIds = BigLoyaltyIds;
var BpcRequest = {
  order: _propTypes.default.shape(Order),
  bigLoyaltyIds: _propTypes.default.arrayOf(BigLoyaltyIds)
};
exports.BpcRequest = BpcRequest;